<div class="app-bg" aria-hidden="true"></div>
<router-outlet></router-outlet>
